import { render, staticRenderFns } from "./PartnerNew.vue?vue&type=template&id=4e1ccde7&scoped=true&"
import script from "./PartnerNew.vue?vue&type=script&lang=js&"
export * from "./PartnerNew.vue?vue&type=script&lang=js&"
import style0 from "./PartnerNew.vue?vue&type=style&index=0&id=4e1ccde7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ccde7",
  null
  
)

export default component.exports